import { render, staticRenderFns } from "./ViAdmissionStudentPaymentHistory.vue?vue&type=template&id=67e55b1e&scoped=true"
import script from "./ViAdmissionStudentPaymentHistory.vue?vue&type=script&lang=js"
export * from "./ViAdmissionStudentPaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./ViAdmissionStudentPaymentHistory.vue?vue&type=style&index=0&id=67e55b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e55b1e",
  null
  
)

export default component.exports